import React from 'react';
import { CONFIG } from '../constants';

const SwishQRModal = ({ 
  selectedBill, 
  onClose, 
  onConfirmPayment 
}) => {
  if (!selectedBill) return null;

  return (
    <div className="billing-modal" onClick={onClose}>
      <div className="billing-modal-content swish-qr-modal" onClick={e => e.stopPropagation()}>
        <h3>Swish-betalning</h3>
        <div className="swish-qr-content">
          <p><strong>Belopp:</strong> {selectedBill.remainingCost} kr</p>
          <p><strong>Meddelande:</strong> {CONFIG.SWISH_MESSAGE}</p>
          <div className="qr-code-container">
            <img 
              src="/swish-qr-code.png" 
              alt="Swish QR Code" 
              className="swish-qr-image"
            />
            <p className="phone-number">{CONFIG.SWISH_PHONE}</p>
          </div>
        </div>
        <div className="modal-buttons">
          <button 
            className="save-button"
            onClick={onConfirmPayment}
          >
            Jag har swishat
          </button>
          <button 
            className="close-button" 
            onClick={onClose}
          >
            Stäng
          </button>
        </div>
      </div>
    </div>
  );
};

export default SwishQRModal;
